export const chatOnboardingPtBR = {
  // UI Elements
  'Step': 'Passo',
  'Back': 'Voltar',
  'Next': 'Próximo',
  'Start Chatting': 'Começar a Conversar',

  // Step Titles
  'Welcome to PickStar AI Chat': 'Bem-vindo ao Chat PickStar AI',
  'Ask Anything About Sports': 'Pergunte Qualquer Coisa Sobre Esportes',
  'Powerful Tools & Features': 'Ferramentas e Recursos Poderosos',
  'Ready to Chat': 'Pronto para Conversar',

  // Step Content
  'Your intelligent sports betting assistant is ready to help. Let me show you how to make the most of our AI-powered chat experience.':
    'Seu assistente inteligente de apostas esportivas está pronto para ajudar. Deixe-me mostrar como aproveitar ao máximo nossa experiência de chat com IA.',

  'Type your questions here. Ask about game predictions, player stats, betting strategies, or any sports-related analysis.':
    'Digite suas perguntas aqui. Pergunte sobre previsões de jogos, estatísticas de jogadores, estratégias de apostas ou qualquer análise relacionada a esportes.',

  'Access key tools: Buy Star Coins for premium features, run Spin the Wheel for detailed game analysis, automate custom prompts with Kits, and browse your full Chat History.':
    'Acesse ferramentas importantes: Compre Star Coins para recursos premium, execute o Gira a Roda para análise detalhada de jogos, automatize prompts personalizados com Kits e navegue por todo seu Histórico de Conversas.',

  'You are all set! Start asking PickStar AI about sports, betting strategies, or game predictions to get expert insights.':
    'Tudo pronto! Comece a perguntar à PickStar AI sobre esportes, estratégias de apostas ou previsões de jogos para obter insights especializados.',
};